/**
 * عکسِ ۳×۴ پرسنل — نمایش، آپلود/جایگزینی، حذف.
 *
 * عکس با هدرِ احراز هویت سرو می‌شود (هیچ مسیرِ عمومی‌ای نیست)، پس به‌شکلِ blob گرفته و
 * به objectURL تبدیل می‌شود. برای پرسنلِ **جدید** (هنوز id ندارد) فایل نگه داشته می‌شود
 * و والد بعد از ساختنِ پرونده آپلودش می‌کند (`onPending`).
 */
import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Space, Tooltip, Typography, Upload, message } from "antd";
import { CameraOutlined, DeleteOutlined } from "@ant-design/icons";
import { deleteEmployeePhoto, fetchEmployeePhoto, uploadEmployeePhoto } from "../api/client";
import { apiError } from "../utils/apiError";

const { Text } = Typography;
const MAX_MB = 8;

export default function EmployeePhoto({ employeeId, hasPhoto, onChanged, onPending, size = 120 }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const [version, setVersion] = useState(0);

  // بارگذاریِ عکسِ فعلی (فقط اگر پرسنل عکس دارد)
  useEffect(() => {
    let alive = true;
    let objUrl = null;
    setUrl(null);
    if (!employeeId || !hasPhoto) return undefined;
    fetchEmployeePhoto(employeeId).then((r) => {
      if (!alive) return;
      objUrl = URL.createObjectURL(r.data);
      setUrl(objUrl);
    }).catch(() => {});
    return () => { alive = false; if (objUrl) URL.revokeObjectURL(objUrl); };
  }, [employeeId, hasPhoto, version]);

  const pick = async (file) => {
    if (!/^image\/(jpeg|png|webp|bmp|gif)$/i.test(file.type)) {
      message.error("فقط JPG یا PNG"); return Upload.LIST_IGNORE;
    }
    if (file.size > MAX_MB * 1024 * 1024) { message.error(`حجمِ عکس بیش از ${MAX_MB} مگابایت است`); return Upload.LIST_IGNORE; }
    if (!employeeId) {
      // پرسنلِ جدید: پیش‌نمایشِ محلی، آپلود بعد از ذخیره
      setUrl(URL.createObjectURL(file));
      if (onPending) onPending(file);
      return false;
    }
    setBusy(true);
    try {
      await uploadEmployeePhoto(employeeId, file);
      message.success("عکس ذخیره شد");
      setVersion((v) => v + 1);
      if (onChanged) onChanged(true);
    } catch (e) { message.error(apiError(e, "آپلودِ عکس ناموفق بود")); }
    setBusy(false);
    return false;
  };

  const remove = async () => {
    if (!employeeId) { setUrl(null); if (onPending) onPending(null); return; }
    setBusy(true);
    try {
      await deleteEmployeePhoto(employeeId);
      setUrl(null);
      message.success("عکس حذف شد");
      if (onChanged) onChanged(false);
    } catch (e) { message.error(apiError(e, "حذف نشد")); }
    setBusy(false);
  };

  const w = size, h = Math.round(size * 4 / 3);
  return (
    <div style={{ display: "flex", gap: 12, alignItems: "flex-start", marginBottom: 12 }}>
      <div style={{
        width: w, height: h, borderRadius: 8, overflow: "hidden", flex: "0 0 auto",
        border: "1px dashed var(--border,#c9d1dc)", background: "var(--surface-2,#f6f8fb)",
        display: "flex", alignItems: "center", justifyContent: "center",
      }}>
        {url
          ? <img src={url} alt="عکس پرسنل" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          : <Text type="secondary" style={{ fontSize: 11, textAlign: "center", padding: 6 }}>عکس ۳×۴</Text>}
      </div>
      <Space direction="vertical" size={6}>
        <Text strong style={{ fontSize: 12.5 }}>عکس پرسنلی</Text>
        <Upload accept="image/*" showUploadList={false} beforeUpload={pick} disabled={busy}>
          <Button size="small" icon={<CameraOutlined />} loading={busy}>
            {url ? "تعویض عکس" : "انتخاب عکس"}
          </Button>
        </Upload>
        {url && (
          <Popconfirm title="عکس حذف شود؟" okText="حذف" cancelText="خیر" onConfirm={remove}>
            <Tooltip title="حذف عکس">
              <Button size="small" danger type="text" icon={<DeleteOutlined />}>حذف</Button>
            </Tooltip>
          </Popconfirm>
        )}
        <Text type="secondary" style={{ fontSize: 11 }}>
          خودکار به ۳×۴ برش می‌خورد؛ در فرمِ ثبت‌نام چاپ می‌شود.
        </Text>
      </Space>
    </div>
  );
}
